// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get, post } from "@insite/client-framework/Services/ApiService";
import { UpdateCustomerPartNumberParameter } from "@steiner/App/Handlers/CustomerPartNumber/UpdateCutsomerPartNumber";

const productBoxesUri = "/api/str/productBox/Boxes?productid=";
const customerPartNumbersUrl = "/api/str/customerpartnumber";

export interface ProductBoxesResponse {
    productBoxes?: ProductBoxModel[];
    errorMessage?: string;
}

export interface ProductBoxModel {
    boxDescription: string;
    boxQty: number;
    qtyOrdered: number;
}

export async function getProductBoxes(productId: string) {
    try {
        const productBoxesResult = await get<ProductBoxesResponse>(`${productBoxesUri + productId}`);
        return productBoxesResult;
    } catch (error) {
        return {
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}

export async function addProductCustomerPartNumber(data: UpdateCustomerPartNumberParameter) {
    await post(`${customerPartNumbersUrl}/addcustomerpartnumber`, {
        customerPartNumber: data.customerPartNumber,
        productNumber: data.productNumber,
    });
}

export async function deleteProductCustomerPartNumber(data: UpdateCustomerPartNumberParameter) {
    await post(`${customerPartNumbersUrl}/deletecustomerpartnumber`, {
        customerPartNumber: data.customerPartNumber,
        productNumber: data.productNumber,
    });
}

export async function updateProductCustomerPartNumber(data: UpdateCustomerPartNumberParameter) {
    await post(`${customerPartNumbersUrl}/updatecustomerpartnumber`, {
        customerPartNumber: data.customerPartNumber,
        productNumber: data.productNumber,
    });
}
